import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { IFrame } from '@klp/iframe';
import { Main } from '@klp/layout';

import { MiljoprofilAccess, MiljoprofilUrl } from '../config';

import { kommentarerAccess } from '@klp/kommentarer/config';
import { KommentarerView } from '@klp/kommentarer';

import { contextSelectors } from '@klp/contextSelector';
import { useCurrentUser } from '@klp/auth';

export default function Miljoprofil() {
    const { t } = useTranslation();
    const { currentUser } = useCurrentUser();
    const { selectedContext } = useSelector(contextSelectors);

    const filteredMiljoprofilLinkHandler = () => {
        let filteredLink = MiljoprofilUrl();

        if (selectedContext?.nummer !== undefined) {
            filteredLink += `?byggnummer=${selectedContext.nummer}&kundenummer=`;
            return filteredLink;
        }

        return filteredLink;
    };
    return (
        <>
            <Main>
                <Main.Breadcrumbs>
                    <Main.Crumb
                        id="miljoprofil"
                        label={t('breadcrumbs.environmentProfile')}
                    />
                </Main.Breadcrumbs>
                {MiljoprofilAccess(currentUser) &&
                    (!selectedContext ? (
                        /* Add a better error message / component here */
                        <div
                            style={{
                                display: 'flex',
                                width: '100%',
                                height: '100%',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <p>{t('environment.noContextSelected')}</p>
                        </div>
                    ) : (
                        <IFrame src={filteredMiljoprofilLinkHandler()} />
                    ))}
            </Main>
            {kommentarerAccess() && <KommentarerView disableDragger={true} />}
        </>
    );
}
